import React, { useMemo, useRef } from "react";
import { useInput } from "react-admin";
import { Helmet } from "react-helmet";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import { divIcon } from "leaflet";
import LocationOnIcon from '@material-ui/icons/LocationOn';

export default function RaLocationInput(props) {
    const { latitudeSource, longitudeSource } = props;

    const { input: { value: parkingLatitude, onChange: setParkingLatitude } } = useInput({ ...props, source: latitudeSource });
    const { input: { value: parkingLongitude, onChange: setParkingLongitude } } = useInput({ ...props, source: longitudeSource });

    const markerRef = useRef(null);

    const coordinate = [parkingLatitude && parkingLatitude.toString().includes(',') ? 28.3788599 : parkingLatitude, parkingLongitude && parkingLongitude.toString().includes(',') ? 77.362603 : parkingLongitude];

    const iconMarkup = renderToStaticMarkup(
        <LocationOnIcon style={{ color: "#18cc69", fontSize: 50 }} />
    );
    const customMarkerIcon = divIcon({
        html: iconMarkup,
        className: 'dummy'
    });

    const eventHandlers = useMemo(() => ({
        dragend() {
            const marker = markerRef.current
            if (marker != null) {
                const latlng = marker.getLatLng();
                setParkingLatitude(latlng.lat);
                setParkingLongitude(latlng.lng);
            }
        }
    }), []); // eslint-disable-line react-hooks/exhaustive-deps

    return (<>
        <Helmet>
            <link rel="stylesheet" href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css" integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A==" crossorigin="" />
        </Helmet>

        <MapContainer
            center={coordinate}
            zoom={17}
            scrollWheelZoom={true}
            style={{ width: "100%", height: "100%" }}

        >
            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker
                ref={markerRef}
                position={coordinate}
                draggable
                eventHandlers={eventHandlers}
                icon={customMarkerIcon}
            />
        </MapContainer>
    </>);
};